import { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import qs from 'qs';

import { getUser } from '../../selectors/user';

import { SetPassword } from '../../screens/SetPassword';
import { SignIn } from '../../screens/SignIn';
import { TokenLogin } from '../../screens/TokenLogin';

type QueryString = {
  token?: string;
  view?: string;
};

export const DefaultRoute: FunctionComponent = () => {
  const user = useSelector(getUser);
  const { token, view }: QueryString = qs.parse(
    window.top?.location.search.slice(1) || ''
  );

  if (view === 'setpassword' && token) {
    return <SetPassword token={token} />;
  }

  if (token && user.error !== undefined) {
    return <TokenLogin token={token} error={user.error} />;
  }

  return <SignIn />;
};
